


























































































































import { EventBus } from "@/event-bus";
import MachinesModal from "@/components/MachinesModal.vue";
import Dropzone from 'dropzone'
import TranslatedItem from "@/components/TranslatedItem.vue";

export default {
  props: ["taskLoaded"],
  data() {
    return {
      dropzone: null,
      unsavedInterval: null,
      filter1: null,
      the_question: null,
      org_entry: {},
      org_machines: [],
      username: null,
      field_message_name_en: [],
      field_message_name_fr: [],
      field_message_instruction_en: [],
      field_message_instruction_fr: [],
      field_message_reportText_en: [],
      field_message_reportText_fr: [],
      showMachines: false,
      sel_addmachines: [],
      sel_removemachines: [],
      sel_machinesingroup: [],
      imagesChanged: false,
      /*
      task_formats: [
        { text: this.$t('LABEL50'), value: "resultFormat/standard" },
        { text: this.$t('LABEL51'), value: "resultFormat/bearing" },
        { text: this.$t('LABEL52'), value: "resultFormat/bladeDamageHKS" },
        { text: this.$t('LABEL53'), value: "resultFormat/flanges" },
        { text: this.$t('LABEL54'), value: "resultFormat/flangeBolting" },
        {
          text: this.$t('LABEL55'),
          value: "resultFormat/foundationCracksConcreteBody",
        },d
        {
          text: this.$t('LABEL56'),
          value: "resultFormat/lighningProtectionRotorBlades",
        },
        {
          text: this.$t('LABEL57'),
          value: "resultFormat/rotorblattschadenCK",
        },
        { text: this.$t('LABEL58'), value: "resultFormat/textarea" },
        { text: this.$t('LABEL59'), value: "resultFormat/toothing" },
      ],
      */
    };
  },
  watch: {
    taskLoaded: function (val, oldVal) {
      this.the_question = null;
      // Dropzone neu initialisieren wenn Task geladen wurde
      if (val && !oldVal) {
        this.$nextTick(() => {
          if (this.$refs.dropzone && !this.dropzone) {
            this.initDropzone()
          }
        })
      }
    },
  },
  components: {
    MachinesModal,
    TranslatedItem,
  },
  computed: {
    task_formats: function () {
      let tk = []
      for (let k of this.$store.state.cl_message_formats) {
        tk.push({ text: k.name, value: k.format_id });
      }
      return tk
    },
    appLang: function () {
      return this.$store.state.lang
    },
    onlyPV: function () {
      return this.$store.getters.userRole.db_region //this.userRole.db_region == 'eso'
    },
    copy_entry() {
      return (
        this.$store.state.copy_entry &&
        this.$store.state.copy_entry.type == "question"
      );
    },
    copy_entry_name() {
      return this.$store.state.copy_entry && this.$store.state.copy_entry.name;
    },
    lblQuestions() {
      return this.$t('CHECKPOINTS') + " (" + this.questions.length + ")";
    },
    entry() {
      if (this.$store.state.cl_task) {
        if (!this.$store.state.cl_task.machinegroup_list) {
          this.$store.state.cl_task.machinegroup_list = [];
        }

        if (this.$store.state.cl_task.machinegroup) {
          if (!this.$store.state.cl_task.machinegroup_created) {
            this.$store.state.cl_task.machinegroup_created = true;
            this.$store.state.cl_task.machinegroup_list = [
              this.$store.state.cl_task.machinegroup,
            ];
          }
        }

        // Stelle sicher, dass example_images existiert
        if (!this.$store.state.cl_task.example_images) {
          this.$set(this.$store.state.cl_task, 'example_images', []);
        }

        this.$store.state.cl_component.machinegroup_created = true;

        return this.$store.state.cl_task;
      }
      return {};
    },
    questions() {
      return this.$store.state.cl_question_list;
    },
    machinegroups() {
      return this.$store.state.cl_machine_groups;
    },
    projects() {
      return this.$store.state.projects;
    },
    saving() {
      return (
        this.$store.state.saving && this.$store.state.saving_type == "task"
      );
    },
    machines() {
      if (this.filter1 && this.filter1.length > 0) {
        return this.$store.state.machines.filter((machine) => {
          return (
            machine.text.toLowerCase().indexOf(this.filter1.toLowerCase()) !==
            -1
          );
        });
      }
      return this.$store.state.machines;
    },
  },
  mounted() {
    EventBus.$on("task_changed", this.taskChangedHandler);
    EventBus.$on("question_closed", this.questionClosedHandler);
    EventBus.$on("entry_added", this.addedHandler);
    EventBus.$on("updateInformElement", this.updateInformElement);
    this.updateUsername();
    // Dropzone erst initialisieren wenn das Element verfügbar ist
    this.$nextTick(() => {
      if (this.$refs.dropzone) {
        this.initDropzone()
      }
    })
  },
  beforeDestroy() {
    if (this.dropzone) {
      this.dropzone.destroy()
    }
  },
  destroyed() {
    EventBus.$off("task_changed", this.taskChangedHandler);
    EventBus.$off("entry_added", this.addedHandler);
    EventBus.$off("question_closed", this.questionClosedHandler);
    EventBus.$off("updateInformElement", this.updateInformElement);
  },
  methods: {
    initDropzone() {
      console.log('Initialisiere Dropzone...')

      if (!this.$refs.dropzone) {
        console.error('Dropzone Element nicht gefunden!')
        return
      }

      try {
        this.dropzone = new Dropzone(this.$refs.dropzone, {
          url: `${this.$apiBase}/checklist/uploadFile`,
          acceptedFiles: '.jpg,.jpeg,.png',
          maxFiles: 5,
          addRemoveLinks: false,
          dictDefaultMessage: this.$t('EXAMPLE_IMAGES_DROPZONE'),
          clickable: true,
          previewTemplate: `
            <div class="dz-preview dz-file-preview">
              <div class="dz-image" style="cursor: pointer;">
                <img data-dz-thumbnail />
              </div>
              <div class="dz-progress">
                <span class="dz-upload" data-dz-uploadprogress></span>
              </div>
              <div class="dz-error-message"><span data-dz-errormessage></span></div>
              <div class="dz-success-mark"><span>✔</span></div>
              <div class="dz-error-mark"><span>✘</span></div>
              <a class="dz-remove" href="javascript:undefined;" data-dz-remove>Remove file</a>
            </div>
          `,
          headers: {
            'x-access-token': localStorage.getItem('token')
          },

          // Events
          success: (file, response) => {

            // Stelle sicher, dass example_images existiert
            if (!this.entry.example_images) {
              this.$set(this.entry, 'example_images', [])
              console.log('example_images array erstellt')
            }

            // Prüfe verschiedene Response-Formate
            let filename = null
            if (typeof response === 'string') {
              try {
                const parsed = JSON.parse(response)
                filename = parsed.fileName || parsed.filename
              } catch (e) {
                filename = response // Falls es direkt der Filename ist
              }
            } else if (response && (response.fileName || response.filename)) {
              filename = response.fileName || response.filename
            }

            console.log('Extracted filename:', filename)

            if (filename) {
              // Datei-Info für spätere Verwendung speichern
              file.serverFilename = filename
              file.fullImageUrl = response.fileUrl

              // Click-Handler für Vollbild hinzufügen
              this.$nextTick(() => {
                if (file.previewElement) {
                  const imageElement = file.previewElement.querySelector('.dz-image')
                  if (imageElement) {
                    imageElement.addEventListener('click', () => {
                      window.open(response.fileUrl, '_blank')
                    })
                  }
                }
              })

              // Bild zum Task hinzufügen
              const imageData = {
                filename: filename,
                fileUrl: response.fileUrl,
                thumbnailFileName: response.thumbnailFileName,
                thumbnailUrl: response.thumbnailUrl,
                originalName: file.name,
                size: file.size,
                uploadDate: new Date().toISOString()
              }

              this.entry.example_images.push(imageData)
              this.imagesChanged = true
              this.save()
            } else {
              console.error('Kein Filename in Response gefunden:', response)
            }
          },
          error: (file, error) => {
            console.error('Upload-Fehler:', error)
            this.$emit('upload-error', error)
          },
          removedfile: (file) => {
            console.log('Datei wird entfernt:', file)

            // Datei vom Server löschen
            this.deleteFile(file)

            // Datei aus entry.example_images entfernen
            if (this.entry.example_images) {
              const filename = file.serverFilename || (file.xhr && JSON.parse(file.xhr.response).filename)
              if (filename) {
                this.entry.example_images = this.entry.example_images.filter(
                  img => img.filename !== filename
                )
                this.imagesChanged = true
                this.save()
              }
            }

            // DOM-Element entfernen (Standard Dropzone Verhalten)
            if (file.previewElement) {
              file.previewElement.remove()
            }

            return true // Wichtig: Event als behandelt markieren
          }
        })

        // Vorhandene Bilder laden
        if (this.entry.example_images) {
          this.entry.example_images.forEach(img => {
            const mockFile = {
              name: img.originalName,
              size: img.size,
              serverFilename: img.filename,
              fullImageUrl: img.fileUrl,
              status: 'success'
            }
            this.dropzone.emit('addedfile', mockFile)
            this.dropzone.emit('complete', mockFile)

            // Bild-URL für Vorschau setzen und Click-Handler hinzufügen
            this.$nextTick(() => {
              if (mockFile.previewElement) {
                const imageUrl = `${this.$apiBase}/inspect-app/image?img=${img.filename}`
                const imgElement = mockFile.previewElement.querySelector('img')
                if (imgElement) {
                  imgElement.src = imageUrl
                }

                // Click-Handler für Vollbild hinzufügen
                const imageContainer = mockFile.previewElement.querySelector('.dz-image')
                if (imageContainer) {
                  imageContainer.addEventListener('click', () => {
                    const fullImageUrl = img.fileUrl || `${this.$apiBase}/inspect-app/image?img=${img.filename}`
                    window.open(fullImageUrl, '_blank')
                  })
                }
              }
            })
          })
        }
      } catch (error) {
        console.error('Fehler beim Initialisieren von Dropzone:', error)
      }
    },
    deleteFile(file) {
      // API-Call zum Löschen der Datei
      let filename = null

      if (file.xhr && file.xhr.response) {
        const response = JSON.parse(file.xhr.response)
        filename = response.filename
      } else if (file.serverFilename) {
        filename = file.serverFilename
      }

      if (filename) {
        this.$http.delete(`/rooms/delete/${filename}`)
          .then(response => {
            console.log('Datei erfolgreich gelöscht:', filename)
          })
          .catch(error => {
            console.error('Fehler beim Löschen der Datei:', error)
          })
      }
    },
    updateInformElement: function (d) {
      if (d.type != "task" && d.uid != this.entry.uid) {
        this.save();
        console.log("TASK speichern");
      }
    },
    updateUsername: function () {
      if (this.entry.user_uid) {
        this.username = this.$store.state.users[this.entry.user_uid];
      } else {
        this.username = "";
      }
    },
    selQuestion: function () {
      this.$emit("selectQuestion", this.the_question);
    },
    save() {
      //this.loading = true;

      let check1 = { ...this.org_entry };
      let check2 = { ...this.entry };
      delete check1.created_at;
      delete check2.created_at;
      delete check1.user_uid;
      delete check2.user_uid;
      delete check1.type;
      delete check2.type;

      this.entry.type = "task";

      if (
        JSON.stringify(check1) != JSON.stringify(check2) ||
        this.entry.machines.length != this.org_machines.length ||
        this.imagesChanged
      ) {
        this.entry.user_uid = this.$store.state.userId;
        this.entry.created_at = Date.now();
        this.org_entry = { ...this.entry };
        this.imagesChanged = false; // Reset nach dem Speichern
        this.updateUsername();
        console.log("entry", this.entry);
        this.$emit("updateAct", this.entry);
        EventBus.$emit("updateInformElement", {
          type: "task",
          uid: this.entry.uid,
        });
      } else {
        this.$emit("updateAct", { no_changes: true });
      }
    },
    createAct: function (type) {
      this.$emit("createAct", { type: type });
    },
    sortAct: function (type) {
      this.$emit("sortAct", { type: type });
    },
    deleteAct: function (type) {
      this.entry.type = type;
      this.$emit("deleteAct", this.entry);
    },
    copyAct: function (type) {
      this.entry.type = type;
      this.$emit("copyAct", {
        type: type,
        cl_uid: this.entry.cl_uid,
        uid: this.entry.uid,
        name: this.entry.name,
      });
    },
    close: function () {
      EventBus.$emit("task_closed", this.entry);
    },
    pasteEntry: function () {
      this.$emit("pasteAct");
    },
    addedHandler: function (data) {
      if (data.type == "question") {
        this.the_question = data.entry_uid;
        this.selQuestion();
      }
    },
    questionClosedHandler: function (data) {
      this.the_question = null;
    },
    taskChangedHandler: function (data) {
      // Stelle sicher, dass example_images initialisiert ist
      if (!this.entry.example_images) {
        this.$set(this.entry, 'example_images', []);
      }
      this.org_entry = { ...this.entry };
      this.org_machines = JSON.parse(JSON.stringify(this.entry.machines));
      this.imagesChanged = false; // Reset beim Task-Wechsel
      this.updateUsername();

      // Deeplink auf den Prüfpunkt
      if (
        this.$store.state.initParams.question &&
        this.$store.state.initParams.question.length > 2 &&
        this.questions.filter(
          (item) => item.value == this.$store.state.initParams.question
        ).length > 0
      ) {
        this.$emit("selectQuestion", this.$store.state.initParams.question);
      }
      // Prüfpunkt wählen, wenn es nur einen gibt
      else if (this.questions.length == 1) {
        this.$emit("selectQuestion", this.questions[0].value);
      }
    },
    dialogClosed: function (val) {
      this.showMachines = false;
    },
    changeMachines: function (val) {
      this.showMachines = false;
      // {add_machines: this.add_machines, remove_machines: this.remove_machines}
      this.entry.machines = val.add_machines;
      this.entry.remove_machines = val.remove_machines;

      if (val.group_uid) {
        // Es wurde eine neue Gruppe aus der Auswahl erstellt
        this.entry.machinegroup_list = [val.group_uid];
      }
    },
    openMachinesDialog: function () {
      this.sel_addmachines = JSON.parse(JSON.stringify(this.entry.machines));
      this.sel_removemachines = JSON.parse(
        JSON.stringify(this.entry.remove_machines)
      );
      this.showMachines = true;

      this.sel_machinesingroup = [];

      if (this.machinegroups) {
        for (let k of this.machinegroups) {
          if (this.entry.machinegroup_list) {
            for (let m of this.entry.machinegroup_list) {
              if (k.value == m) {
                this.sel_machinesingroup = this.sel_machinesingroup.concat(
                  JSON.parse(JSON.stringify(k.machines))
                );
              }
            }
          } else {
            if (k.value == this.entry.machinegroup) {
              this.sel_machinesingroup = JSON.parse(JSON.stringify(k.machines));
              break;
            }
          }
        }
      }
    },

  },
};
